module.exports = __webpack_public_path__ + "img/responsive crc-07.d1dd4a58.jpg";